export default __webpack_public_path__ + "static/media/clinicsoul.f47c0609.png";